import uuid from 'uuid/v4';
import RequestUrls from '@Constants/RequestUrlsConstants';
import MessageBroker from '@Services/MessageBroker';

import { MAP_CONTEXTS } from '@Pages/Hopinto/constants';
import { setFullTextDocumentId } from './FullTextResults';
import { _resolveAuth, _goToQuickSearch, _goToAdvancedSearch } from './utils';

// eslint-disable-next-line import/prefer-default-export
export const resolveFullText = _resolveAuth(async ({ query, context, origin }) => {
  try {
    // Avoid catastrophic backtracking by using a bounded, safer regex.
    // Build via RegExp constructor so escapes are explicit and we don't use the global flag.
    // Match pattern like "word.word = '12345'" but limit each word to 1..100 chars and id to 1..20 digits.
    const safeRegex = /\b\w{1,100}\.\w{1,100}\s*=\s*'?(\d{1,20})'?/i;
    const fullTextDocumentIdMatches = typeof query === 'string' ? safeRegex.exec(query) : null;
    const fullTextDocumentId = fullTextDocumentIdMatches && fullTextDocumentIdMatches[1];

    const queryFactItem = await MessageBroker.send(RequestUrls.hopInto, { query, context, origin });

    if (fullTextDocumentId) {
      setFullTextDocumentId(fullTextDocumentId);
    } else {
      Logger.error('Hopinto/FullText - document id could not be parsed from query', query);
    }

    const request = {
      context: MAP_CONTEXTS[context] || context,
      queryFactItem,
      searchId: uuid(),
    };

    _goToAdvancedSearch({
      importedQuery: request,
      autoSearch: 'hopInto',
    });
    // eslint-disable-next-line sonarjs/no-ignored-exceptions,no-unused-vars
  } catch (e) {
    _goToQuickSearch();
  }
});
